'use client';

import { Facebook, Linkedin, MessageCircle } from 'lucide-react';

import styles from './article-blocks.module.css';

export function ArticleShare({ locale }: { locale: string }) {
  const isArabic = locale.startsWith('ar');
  const networks = [
    { name: 'Facebook', icon: Facebook, href: (url: string, title: string) => `https://www.facebook.com/sharer.php?u=${url}&t=${title}` },
    { name: 'WhatsApp', icon: MessageCircle, href: (url: string, title: string) => `https://wa.me/?text=${title}%20${url}` },
    { name: 'LinkedIn', icon: Linkedin, href: (url: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${url}` },
  ];

  return (
    <div className={styles.share}>
      {networks.map(({ name, icon: Icon, href }) => (
        <button
          key={name}
          type="button"
          aria-label={isArabic ? `مشاركة عبر ${name}` : `Share on ${name}`}
          onClick={(event) => {
            const document = event.currentTarget.ownerDocument;
            const view = document.defaultView;
            if (!view) return;
            const url = encodeURIComponent(`${view.location.origin}${view.location.pathname}`);
            const title = encodeURIComponent(document.querySelector('[data-test="landing-page-banner"] h1')?.textContent ?? document.title);
            view.open(href(url, title), '_blank', 'noopener,noreferrer');
          }}
        >
          <Icon size={18} aria-hidden />
        </button>
      ))}
    </div>
  );
}
